import React, { useContext } from "react";
import "../css/dashboard.css";
import ClientsContent from "./ClientsContent";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import NavbarV2 from "../component/NavbarV2";
import ProfileWidgetMobileNoRole from "../component/ProfileWidgetMobileNoRole";
import ClientsContentV2Mobile from "./ClientsContentV2Mobile";
import { LanguageContext } from "../context/LanguageContext";

export default function Clients() {
  const { translate } = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div
            className="menu-button-container-mobile"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingRight: "0%",
            }}
          >
            <div
              style={{
                width: "30%",
                paddingLeft: "5%",
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
                className="menu-button"
              >
                <MenuIcon />
              </IconButton>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "40%",
                alignItems: "center",
                alignContent: "center",
                alignSelf: "center",
                fontWeight: "700",
              }}
            >
              {translate("Clients")}
            </div>
            <div
              style={{
                width: "30%",
                paddingTop: "0px",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "end",
                alignContent: "center",
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              ></div>
              <ProfileWidgetMobileNoRole />
            </div>
          </div>

          <ClientsContentV2Mobile />
        </>
      ) : (
        <>
          <NavbarV2 linkActive={1} />
          <ClientsContent selectedTab={location.state?.selectedTab} />
        </>
      )}
    </div>
  );
}
